import React from "react";
import styled, { css } from "styled-components";
import { BodySemibold } from "storybook-components/Typography";

const CategoryLabelDiv = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 8px;
  border-radius: 4px;
  ${props => props.isActive && css`
    background-color: ${({ theme }) => theme.colors.green4};
  `};
`;

const StyledLabelText = styled(BodySemibold)`
  margin: 0;
  color: ${({ theme }) => theme.colors.green5};
  &:hover {
    color: ${({ theme }) => theme.colors.gray12};}
  }
  ${props => props.isActive && css`
    color: ${({ theme }) => theme.colors.green1};
    &:hover {
      color: ${({ theme }) => theme.colors.green1};}
    }
  `};
`;

const CategoryLabel = ({ children, className, isActive }) => {
  return (
    <CategoryLabelDiv className={className} isActive={isActive}>
      <StyledLabelText isActive={isActive}>{isActive}{children}</StyledLabelText>
    </CategoryLabelDiv>
  );
};

export default CategoryLabel;
